import {
    DesktopNotificationSetting,
    NotificationSettingValue,
    MessageNotificationSetting,
    settingName,
} from './Constants';
import { ObservableMap } from 'mobx';
import { setNotificationSettings } from '../mutators/setDesktopNotifications';
import saveDesktopNotificationSetting from './saveDesktopNotificationSetting';
import { logUsage } from 'owa-analytics';
import { makeGetRequest } from 'owa-ows-gateway';
import { DESKTOP_SETTINGS_URL } from '../utils/Constants';

let desktopNotificationSettingsPromise;
export default async function loadDesktopNotificationSettings(): Promise<boolean> {
    if (desktopNotificationSettingsPromise) {
        desktopNotificationSettingsPromise;
    }

    desktopNotificationSettingsPromise = makeGetRequest(DESKTOP_SETTINGS_URL)
        .then(value => {
            if (value) {
                if (value.length == 0) {
                    let settings = new ObservableMap<
                        DesktopNotificationSetting,
                        NotificationSettingValue
                    >();
                    settings.set(DesktopNotificationSetting.DesktopSettingEnabled, true);
                    settings.set(
                        DesktopNotificationSetting.EventReminderNotificationSettingEnabled,
                        true
                    );
                    settings.set(
                        DesktopNotificationSetting.NewMailNotificationSettingEnabled,
                        true
                    );
                    settings.set(
                        DesktopNotificationSetting.NewMailNotificationOption,
                        MessageNotificationSetting.Inbox
                    );
                    setNotificationSettings(settings);
                    saveDesktopNotificationSetting();
                    logUsage('NativeNotificationSettingsInitializedSuccesfully');
                }

                if (value[0].name === settingName) {
                    try {
                        let mappedSettings = new ObservableMap<
                            DesktopNotificationSetting,
                            NotificationSettingValue
                        >();
                        const settings = JSON.parse(value[0].value);
                        Object.keys(settings).forEach(key => {
                            mappedSettings.set(
                                key as DesktopNotificationSetting,
                                settings[key] as NotificationSettingValue
                            );
                        });
                        logUsage('NativeNotificationSettingsLoadedSuccessfully');
                        setNotificationSettings(mappedSettings);
                    } catch {
                        logUsage('NativeNotificationSettingsParseFailure');
                    }
                }
            }
            return true;
        })
        .catch(function (err) {
            logUsage('NativeNotificationSettingsLoadFailure', {
                error: err.message,
            });
        });
    return desktopNotificationSettingsPromise;
}
